/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
//#endregion
//#region Components
import HelmetUTP from "components/HelmetUTP/HelmetUTP";
import EmptyView from "views/components/EmptyView/EmptyView";
import Preloader from "components/Preloader/Preloader";
import ScheduleComponent from "./components/SchedulesComponent/SchedulesComponent";
//#endregion
//#region Icons
import CalendarIcon from "icons/CalendarIcon";
//#endregion
//#region Services
import { requestUserHasAssociatedAppointments } from "services/appointment/aboutAppoinment";
import { getUserId } from "services/storage/general";
//#endregion
//#region Utils
import { USER_ROLES } from "config/userPermissions";
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import useMainContext from "utils/context/useMainContext";
//#endregion

const BUTTON_PROPS_FOR_EMPTY_VIEW = {
    props: {
        text: "Crear asesoría",
        icon: <CalendarIcon/>,
    },
    to: ABSOLUTE_PATHS.CREATE_APPOINTMENT
};

// requestUserHasAssociatedAppointments
const AppointmentSchedules = ({
    userRole, 
}) => {
    const mainContext = useMainContext();
    const navigate = useNavigate();
    //#region States
    const [currentUserHasAppointments, setCurrentUserHasAppointments] = useState(null);
    const [fatalError, setFatalError] = useState(false);
    //#endregion
    //#region Effects
    useEffect(() => {
        verifyIfCurrentUserHasAppointments();
    }, [userRole]);
    useEffect(() => {
        if (!fatalError || mainContext.showDialogUnexpectedError) return;
        navigate(ABSOLUTE_PATHS.HOME);
    }, [mainContext.showDialogUnexpectedError]);
    //#endregion
    //#region Functions
    const verifyIfCurrentUserHasAppointments = async () => {
        if (!userRole) return;
        const userId = getUserId();
        if (!userId) return;
        const hasAppointments = await requestUserHasAssociatedAppointments();
        if (hasAppointments !== null) {
            setCurrentUserHasAppointments(hasAppointments);
            return;
        }
        setFatalError(true);
        mainContext.setShowDialogUnexpectedError(true);
    }
    //#endregion
    const isAppointmentCoordinator = userRole !== USER_ROLES.ASESORIAS_PSICOLOGO;
    return (
        <>
            <HelmetUTP title="Asesoría"/>
            <Preloader 
                message="Cargando..." 
                hidden={currentUserHasAppointments !== null || fatalError}/>
            {currentUserHasAppointments !== null && 
                (currentUserHasAppointments
                ? <ScheduleComponent userRole={userRole}/>
                : <EmptyView
                    isCoordinator={isAppointmentCoordinator}
                    buttonProps={BUTTON_PROPS_FOR_EMPTY_VIEW}
                    as="psicólogo"/>)}
        </>
    );
}

export default AppointmentSchedules;